import PublishOutlinedIcon from '@mui/icons-material/PublishOutlined'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import { ButtonLink } from '../../../components/wrappers/Button'
import type { TtoggleDrawerOnMobile } from '../../../containers/Sidebar/Sidebar'
import { PUBLISH_PATH } from './paths'

export interface MenuReviewPublishProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export default function MenuReviewPublish({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuReviewPublishProps) {
  const { formatMessage } = useIntl()

  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href={PUBLISH_PATH}
        selected={pathname.startsWith(PUBLISH_PATH)}
      >
        <ListItemIcon>
          <PublishOutlinedIcon />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({ id: 'avatarStudio.draft.reviewAndPublish' })}
        />
      </MenuItem>
    </div>
  )
}
